export default "__VITE_ASSET__BWYoN7kb__"